module.exports = __webpack_public_path__ + "img/about-section-img.4eee36ee.jpg";